let closeCustom = document.querySelector(".custom-chat-icon_div");
closeCustom?.addEventListener("click", function () {
  const hostElement2 = document.querySelector(
    "#shopify-chat inbox-online-store-chat"
  );
  const shadowRoot2 = hostElement2.shadowRoot;
  const elementInsideShadow2 = shadowRoot2.querySelector(".chat-toggle");
  const elementCloseShadow2 = shadowRoot2.querySelector(
    ".chat-app--close-button"
  );
  const elementCloseShadowMobile2 = shadowRoot2.querySelector(
    'button[name="closeChat"]'
  );
  document.querySelector("#shopify-chat").style.visibility = "visible";
  elementInsideShadow2?.click();
});
setTimeout(function () {
  let closeCustom = document.querySelector(".custom-chat-icon_div");
  closeCustom?.addEventListener("click", function () {
    const hostElement = document.querySelector(
      "#shopify-chat inbox-online-store-chat"
    );
    const shadowRoot = hostElement.shadowRoot;
    const elementInsideShadow = shadowRoot.querySelector(".chat-toggle");
    const elementCloseShadow = shadowRoot.querySelector(
      ".chat-app--close-button"
    );
    const elementCloseShadowMobile = shadowRoot.querySelector(
      'button[name="closeChat"]'
    );
    document.querySelector("#shopify-chat").style.visibility = "visible";
    elementInsideShadow?.click();
  });
}, 2000); // Interval of 1 second (1000 milliseconds)

setInterval(function () {
  const hostElement1 = document.querySelector(
    "#shopify-chat inbox-online-store-chat"
  );
  const shadowRoot1 = hostElement1.shadowRoot;
  const elementInsideShadow1 = shadowRoot1.querySelector(".chat-toggle");
  const elementCloseShadow1 = shadowRoot1.querySelector(
    ".chat-app--close-button"
  );
  const elementCloseShadowMobile1 = shadowRoot1.querySelector(
    'button[name="closeChat"]'
  );
  if (elementCloseShadow1) {
    elementCloseShadow1.addEventListener("click", function () {
      document.querySelector("#shopify-chat").style.visibility = "hidden";
    });
  }
  if (elementCloseShadowMobile1) {
    elementCloseShadowMobile1.addEventListener("click", function () {
      document.querySelector("#shopify-chat").style.visibility = "hidden";
    });
  }
}, 1000); // Interval of 1 second (1000 milliseconds)
